/* eslint-disable no-param-reassign */
import {createSlice} from '@reduxjs/toolkit'
import React from "react";
import dayjs from "dayjs";
import store from 'store'
import {createAccount} from "../services/accounts";
import _ from "lodash";

const initialState = {
    sortBy: "roi",
    list: []
}

export const accountSlice = createSlice({
    name: 'accounts',
    initialState,
    reducers: {
        setAccounts: (state, action) => {
            state.list = action.payload;
        },
        addAccount: (state, action) => {
            createAccount(action.payload);
            let account = createAccount(action.payload.address);
            account.heroes =
                [
                    {name: "SL", value: action.payload.sl || 0},
                    {name: "L", value: action.payload.l || 0},
                    {name: "EP", value: action.payload.ep || 0},
                    {name: "SR", value: action.payload.sr || 0},
                    {name: "R", value: action.payload.r || 0},
                    {name: "CM", value: action.payload.cm || 0}
                ];

            state.list.push(account);
            store.set('bomb_accounts', state.list);

            window.gtag("event", "add account", {
                event_category: "account",
                event_label: action.payload.address,
                value: action.payload.address
            });
        },
        deleteAccount: (state, action) => {
            let accounts = _.reject(state.list, function (acc) {
                return acc.address === action.payload;
            });

            if (accounts) {
                state.list = accounts;
                store.set('bomb_accounts', state.list);
            }

            window.gtag("event", "delete account", {
                event_category: "account",
                event_label: action.payload.address,
                value: action.payload.address
            });
        },
        setupAccount: (state, action) => {
            let result = action.payload;

            if (result) {
                result.amount_of_bcoin = 0;
                result.amount_of_bcoin_claimed = 0;
                result.lasted_claimed = 0;
                if (result.items) {
                    result.lasted_claimed = dayjs(result.items[0].claimed_at).unix() * 1000;
                    result.items.map(item => {
                        if (item.status === "successful") {
                            result.amount_of_bcoin += item.amount || 0;
                            result.amount_of_bcoin_claimed += item.amount_of_bcoin_claimed || 0;
                        }
                    });
                }
            }

            let account = _.find(state.list, {address: action.payload.address});
            if (account) {
                account.amount_of_bcoin = result.amount_of_bcoin;
                account.amount_of_bcoin_claimed = result.amount_of_bcoin_claimed;
                account.lasted_claimed = result.lasted_claimed;
                account.items = result.items || [];
            } else {
                account = createAccount(result.address);
                account.amount_of_bcoin = result.amount_of_bcoin;
                account.amount_of_bcoin_claimed = result.amount_of_bcoin_claimed;
                account.lasted_claimed = result.lasted_claimed;
                account.items = result.items || [];
                state.list.push(createAccount(action.payload));
            }

            store.set('bomb_accounts', state.list);
        },
        setSortBy: (state, action) => {
            switch (action.payload) {
                case "funding":
                    state.sortBy = "funding";
                    break;
                case "amount_of_bcoin_claimed":
                    state.sortBy = "amount_of_bcoin_claimed";
                    break;
                case "lasted_claimed":
                    state.sortBy = "lasted_claimed";
                    break;
                case "roi":
                    state.sortBy = "roi";
                    break;
                default:
                    state.sortBy = "roi";
                    break;
            }
        },
        updateAccount: (state, action) => {
            let result = action.payload;

            let contract = ["0x30cc0553f6fa1faf6d7847891b9b36eb559dc618", "0xea3516feb8f3e387eec3004330fd30aff615496a"];
            let invest_amount = 0;

            if (result.transaction) {
                result.transaction.map(tx => {
                    tx.interactions.map(interactions => {
                        // check function
                        if (contract.includes(interactions.to)) {

                            // calculate invest
                            tx.transfers.map(tran => {
                                invest_amount += Number(tran.balance) || 0;
                            });
                        }
                    })

                });

                let account = _.find(state.list, {address: action.payload.address});
                if (account) {
                    account.funding = invest_amount;
                }

                store.set('bomb_accounts', state.list);
            }
        },
    },
})

// Actions
export const {setAccounts, addAccount, deleteAccount, setupAccount, setSortBy, updateAccount} = accountSlice.actions;
export default accountSlice.reducer
